import getUniqueValues from 'src/js/modules/utils/get-unique-values';

const getOptionNestedAttributes = (option) => {
  const mainAttributes = option.attributes || [];
  const subOptionsAttributes =
    option.options?.flatMap((subOption) => getOptionNestedAttributes(subOption)) || [];

  return getUniqueValues([...mainAttributes, ...subOptionsAttributes]);
};

export default getOptionNestedAttributes;
